import { http } from 'http';

export default {
  saveData: (transactionId, data) =>
    http.patch(`/actas/${transactionId}`, data, {
      headers: {
        'content-type': 'application/json-patch+json'
      }
    })
};
